const chunkMapping = {
	"1076": [
		21076
	],
	"2131": [
		2131
	],
	"3572": [
		71191
	],
	"3834": [
		43834
	],
	"4868": [
		14868
	],
	"5298": [
		95298
	],
	"6394": [
		6394
	],
	"6745": [
		96745
	],
	"7551": [
		57551
	],
	"8345": [
		78345
	]
};
const idToExternalAndNameMapping = {
	"2131": [
		"default",
		"./WorkerBackgroundScreening",
		58642
	],
	"6394": [
		"default",
		"./WorkerPendingSterling",
		58642
	],
	"14868": [
		"default",
		"./App",
		58642
	],
	"21076": [
		"default",
		"./PendingSterling",
		58642
	],
	"43834": [
		"default",
		"./ProjectSterlingEnrollment",
		58642
	],
	"57551": [
		"default",
		"./ProjectWorkerScreenings",
		58642
	],
	"71191": [
		"default",
		"./CompanyBackgroundScreening",
		58642
	],
	"78345": [
		"default",
		"./SterlingPortal",
		58642
	],
	"95298": [
		"default",
		"./ProjectBackgroundScreening",
		58642
	],
	"96745": [
		"default",
		"./App",
		61196
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			let getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			const data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			const onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			const handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					const promise = fn(arg1, arg2);
					if(promise?.then) {
						const p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			const onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			const onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			const onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}